import { PreviewCardProperty } from '@zeiss/beyond-online-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { StyledPreviewCard } from 'src/components/shared/StyledPreviewCard';
import { TenantResponse } from 'src/types/rest/tenant';

type TenantCardProps = Pick<
  TenantResponse,
  'id' | 'name' | 'organization' | 'usersCount'
>;

export const TenantCard = ({
  id,
  name,
  organization,
  usersCount,
}: TenantCardProps) => {
  const { t } = useTranslation(['common']);
  const navigate = useNavigate();

  let properties: PreviewCardProperty[] = [
    {
      key: t('common:glossary.member', { count: usersCount }),
      value: `${usersCount}`,
    },
  ];

  if (organization) {
    properties = [
      {
        key: t('common:glossary.organization'),
        value: organization.name,
      },
      ...properties,
    ];
  }

  return (
    <StyledPreviewCard
      chips={null}
      desktopVariant="grid-item"
      headline={name}
      link={() => navigate(`${id}`)}
      properties={properties}
    />
  );
};
